// src/characters/catalog.ts
var CHARACTERS = [
  {
    id: "fairy",
    label: "Fairy",
    emoji: "\u{1F9DA}",
    kind: "flyer",
    heightM: 0.35,
    waveNode: "ArmR",
    feedable: false,
    blurb: "The trail fairy, in the look chosen below. Hovers and waves her wand."
  },
  {
    id: "fox",
    label: "Fox",
    emoji: "\u{1F98A}",
    kind: "runner",
    heightM: 0.5,
    waveNode: "LegFR",
    feedable: false,
    blurb: "A bushy-tailed fox that trots about, then sits up and waves a paw."
  },
  {
    id: "bunny",
    label: "Bunny",
    emoji: "\u{1F430}",
    kind: "runner",
    heightM: 0.45,
    waveNode: "ArmR",
    feedable: false,
    blurb: "A round white rabbit with pink ears that hops around and waves."
  },
  {
    id: "penguin",
    label: "Penguin",
    emoji: "\u{1F427}",
    kind: "runner",
    heightM: 0.55,
    waveNode: "ArmR",
    feedable: false,
    blurb: "A little penguin in a knitted blue hat and scarf, with a snowy white face and belly."
  },
  {
    id: "polarBear",
    label: "Baby polar bear",
    emoji: "\u{1F43B}\u200D\u2744\uFE0F",
    kind: "runner",
    heightM: 0.55,
    waveNode: "ArmR",
    feedable: true,
    food: "cookie",
    blurb: "A bright-eyed polar bear cub in a cosy green scarf. Loves cookies."
  },
  {
    id: "robot",
    label: "Robot",
    emoji: "\u{1F916}",
    kind: "runner",
    heightM: 0.6,
    waveNode: "ArmR",
    feedable: false,
    blurb: "A friendly tin robot with glowing eyes and a blinking antenna."
  },
  {
    id: "dragon",
    label: "Baby dragon",
    emoji: "\u{1F409}",
    kind: "flyer",
    heightM: 0.55,
    waveNode: "ArmR",
    feedable: true,
    food: "marshmallow",
    blurb: "A coral hatchling with curved horns, a long curled tail and golden wings. Loves marshmallows."
  },
  {
    id: "frostDragon",
    label: "Frost dragon",
    emoji: "\u2744\uFE0F",
    kind: "flyer",
    heightM: 0.55,
    waveNode: "ArmR",
    feedable: true,
    food: "snowball",
    blurb: "An ice-blue hatchling with crystal horns, sweeping wings and a cosy winter scarf. Loves snowballs."
  },
  {
    id: "gingerbreadUnicorn",
    label: "The Magical Gingerbread Unicorn",
    emoji: "\u{1F984}",
    kind: "flyer",
    heightM: 0.7,
    waveNode: "LegFR",
    feedable: true,
    food: "candy",
    blurb: "Our magical gingerbread pony, with iced biscuit wings, a golden spiral horn and a rainbow candy mane. Loves sweets."
  },
  {
    id: "ghost",
    label: "Ghost",
    emoji: "\u{1F47B}",
    kind: "flyer",
    heightM: 0.6,
    waveNode: "ArmR",
    feedable: false,
    blurb: "A friendly little ghost that drifts about and waves."
  },
  {
    id: "owl",
    label: "Owl",
    emoji: "\u{1F989}",
    kind: "flyer",
    heightM: 0.45,
    waveNode: "ArmR",
    feedable: false,
    blurb: "A wide-eyed owl that hovers on slow wingbeats."
  },
  {
    id: "pumpkin",
    label: "Giant pumpkin",
    emoji: "\u{1F383}",
    kind: "flyer",
    heightM: 1.1,
    waveNode: "ArmR",
    feedable: true,
    food: "candy",
    blurb: "A huge floating jack-o-lantern with a hungry mouth. Feed it sweets."
  },
  {
    id: "monster",
    label: "Fluffy monster",
    emoji: "\u{1F47E}",
    kind: "flyer",
    heightM: 1.1,
    waveNode: "ArmR",
    feedable: true,
    food: "cookie",
    blurb: "A cuddly lavender monster with a bright eye and little green wings. Loves cookies."
  },
  {
    id: "snowman",
    label: "Snowman",
    emoji: "\u26C4",
    kind: "flyer",
    heightM: 1.2,
    waveNode: "ArmR",
    feedable: true,
    // Not snowballs: a snowman eating snow is eating itself (as a tester
    // pointed out). Ice cream is cold enough to suit it.
    food: "iceCream",
    blurb: "A jolly snowman with a sweet tooth. Loves ice cream, the colder the better."
  },
  {
    id: "frog",
    label: "Frog",
    emoji: "\u{1F438}",
    kind: "flyer",
    heightM: 0.9,
    waveNode: "ArmR",
    feedable: true,
    food: "fly",
    blurb: "A big green frog with a wide mouth. Feed it flies."
  },
  {
    id: "reindeer",
    label: "Reindeer",
    emoji: "\u{1F98C}",
    kind: "runner",
    heightM: 0.7,
    waveNode: "LegFR",
    feedable: true,
    food: "carrot",
    blurb: "A red-nosed reindeer that trots about and lifts a hoof. Loves carrots."
  },
  {
    id: "elf",
    label: "Elf",
    emoji: "\u{1F9DD}",
    kind: "runner",
    heightM: 0.6,
    waveNode: "ArmR",
    feedable: true,
    food: "candy",
    blurb: "A cheery elf in a green hat and stripy tights who runs about and waves."
  },
  {
    id: "robin",
    label: "Cool Robin",
    emoji: "\u{1F426}",
    kind: "flyer",
    heightM: 0.3,
    waveNode: "ArmR",
    feedable: false,
    blurb: "A puffed-up redbreast in aviator sunglasses and headphones, convinced he is the coolest bird on the trail."
  },
  {
    id: "gingerbread",
    label: "Gingerbread man",
    emoji: "\u{1F36A}",
    kind: "runner",
    heightM: 0.55,
    waveNode: "ArmR",
    feedable: false,
    blurb: "Run, run, as fast as you can: a gingerbread man who stops to wave."
  },
  {
    id: "goblin",
    label: "Garden goblin",
    emoji: "\u{1F47A}",
    kind: "runner",
    heightM: 0.55,
    waveNode: "ArmR",
    feedable: true,
    food: "candy",
    blurb: "A leaf-haired little goblin with tiny tusks, a leather sash and a sweet tooth."
  },
  {
    id: "werewolf",
    label: "Little werewolf",
    emoji: "\u{1F43A}",
    kind: "runner",
    heightM: 0.65,
    waveNode: "ArmR",
    feedable: true,
    food: "cookie",
    blurb: "A fluffy, checked-shirt wolf cub who bounds along with a wagging tail."
  },
  {
    id: "skeletonMage",
    label: "Skeleton mage",
    emoji: "\u{1F9D9}",
    kind: "runner",
    heightM: 0.7,
    waveNode: "ArmR",
    feedable: true,
    food: "marshmallow",
    blurb: "A friendly bony wizard in a crooked hat, carrying a little lantern."
  },
  {
    id: "witch",
    label: "Little witch",
    emoji: "\u{1F9D9}\u200D\u2640\uFE0F",
    kind: "runner",
    heightM: 0.65,
    waveNode: "ArmR",
    feedable: true,
    food: "candy",
    blurb: "A green-skinned witch with a black bob, a crooked hat and striped stockings, with a cheerful wave."
  },
  {
    id: "broomWitch",
    label: "Broomstick witch",
    emoji: "\u{1F9F9}",
    kind: "flyer",
    heightM: 0.7,
    waveNode: "ArmR",
    feedable: true,
    food: "candy",
    blurb: "A little witch riding a golden-bristled broom, with tucked knees and a friendly wave."
  },
  {
    id: "skeleton",
    label: "Skeleton",
    emoji: "\u{1F480}",
    kind: "runner",
    heightM: 0.6,
    waveNode: "ArmR",
    feedable: true,
    food: "marshmallow",
    blurb: "A cheerful, big-eyed skeleton with a little rib cage and dancing bones."
  },
  {
    id: "frankenstein",
    label: "Frankenstein\u2019s Monster",
    emoji: "\u{1F9DF}",
    kind: "runner",
    heightM: 0.7,
    waveNode: "ArmR",
    feedable: true,
    food: "cookie",
    blurb: "A gentle green monster with a flat haircut, neck bolts, a patched jacket and big curious eyes."
  },
  {
    id: "zombie",
    label: "Sweet-tooth zombie",
    emoji: "\u{1F9DF}",
    kind: "runner",
    heightM: 0.6,
    waveNode: "ArmR",
    feedable: true,
    food: "candy",
    blurb: "A cheerful patchwork zombie with leafy hair and a lopsided shuffle."
  },
  {
    id: "santa",
    label: "Santa",
    emoji: "\u{1F385}",
    kind: "runner",
    heightM: 0.8,
    waveNode: "ArmR",
    feedable: true,
    food: "cookie",
    blurb: "Rosy cheeks, a curly beard, a swaying sack and an appetite for cookies."
  },
  {
    id: "nutcracker",
    label: "Nutcracker",
    emoji: "\u{1F941}",
    kind: "runner",
    heightM: 0.75,
    waveNode: "ArmR",
    feedable: true,
    food: "marshmallow",
    blurb: "A toy soldier with gold braiding, a feathered hat and a jaunty march."
  },
  {
    id: "bat",
    label: "Velvet bat",
    emoji: "\u{1F987}",
    kind: "flyer",
    heightM: 0.45,
    waveNode: "ArmR",
    feedable: true,
    food: "fly",
    blurb: "Huge velvet ears and scalloped wings; quick, buoyant wingbeats."
  }
];
var CHARACTER_IDS = CHARACTERS.map((c) => c.id);
var PHOTO_CHARACTERS = CHARACTERS.filter(
  (c) => c.id !== "snowman" && c.id !== "frog"
);
var FEEDABLE_CHARACTERS = CHARACTERS.filter((c) => c.feedable);
var characterSpec = (id) => CHARACTERS.find((c) => c.id === id) ?? CHARACTERS[0];
var isCharacterId = (value) => CHARACTERS.some((c) => c.id === value);
var FOODS = {
  candy: {
    id: "candy",
    label: "sweets",
    emoji: "\u{1F36C}",
    radiusM: 0.05,
    colors: ["#ff5c8a", "#ffe066"]
  },
  marshmallow: {
    id: "marshmallow",
    label: "marshmallows",
    emoji: "\u{1F361}",
    radiusM: 0.055,
    colors: ["#fff4f0", "#ffc9d9"]
  },
  cookie: {
    id: "cookie",
    label: "cookies",
    emoji: "\u{1F36A}",
    radiusM: 0.06,
    colors: ["#c98a4b", "#5a3a22"]
  },
  snowball: {
    id: "snowball",
    label: "snowballs",
    emoji: "\u2744\uFE0F",
    radiusM: 0.06,
    colors: ["#f4f9ff", "#d5e8ff"]
  },
  fly: {
    id: "fly",
    label: "flies",
    emoji: "\u{1FAB0}",
    radiusM: 0.04,
    colors: ["#3a3a3a", "#b9d9ff"]
  },
  carrot: {
    id: "carrot",
    label: "carrots",
    emoji: "\u{1F955}",
    radiusM: 0.05,
    colors: ["#ff8a2a", "#3f9a3a"]
  },
  iceCream: {
    id: "iceCream",
    label: "ice creams",
    emoji: "\u{1F366}",
    radiusM: 0.05,
    colors: ["#ffb3c6", "#d9a066"]
  }
};
var CHARACTER_ASSETS_BASE_URL = "/characters";
var characterModelUrl = (id) => `${CHARACTER_ASSETS_BASE_URL}/${id}.glb`;
var prefetchCharacter = (id) => {
  if (typeof fetch !== "function") return;
  void fetch(characterModelUrl(id), { mode: "same-origin" }).catch(
    () => void 0
  );
};
function characterMotion(id) {
  if (id === "fox" || id === "reindeer") return "trot";
  if (id === "bunny" || id === "frog") return "hop";
  if (id === "penguin") return "penguin";
  if (id === "santa") return "waddle";
  if (id === "polarBear") return "bear";
  if (id === "snowman" || id === "gingerbread") return "cuteBiped";
  if (id === "nutcracker" || id === "robot") return "march";
  if (id === "skeletonMage") return "mage";
  if (id === "broomWitch") return "broom";
  if (id === "witch" || id === "skeleton" || id === "frankenstein")
    return "cuteBiped";
  if (id === "zombie") return "shuffle";
  if (id === "robin") return "robin";
  if (id === "fairy") return "fairy";
  if (id === "monster") return "plush";
  if (id === "bat") return "flutter";
  if (id === "dragon" || id === "frostDragon") return "dragon";
  if (id === "gingerbreadUnicorn") return "unicorn";
  if (id === "owl") return "soar";
  if (id === "ghost" || id === "pumpkin") return "float";
  return "biped";
}
function characterCollection(id) {
  if ([
    "goblin",
    "werewolf",
    "skeletonMage",
    "witch",
    "broomWitch",
    "skeleton",
    "frankenstein",
    "zombie",
    "bat",
    "ghost",
    "pumpkin",
    "monster"
  ].includes(id))
    return "Halloween";
  if ([
    "frostDragon",
    "gingerbreadUnicorn",
    "santa",
    "nutcracker",
    "elf",
    "reindeer",
    "robin",
    "gingerbread",
    "snowman",
    "penguin",
    "polarBear"
  ].includes(id))
    return "Christmas";
  return "Woodland";
}

export {
  CHARACTERS,
  CHARACTER_IDS,
  PHOTO_CHARACTERS,
  FEEDABLE_CHARACTERS,
  characterSpec,
  isCharacterId,
  FOODS,
  CHARACTER_ASSETS_BASE_URL,
  characterModelUrl,
  prefetchCharacter,
  characterMotion,
  characterCollection
};
//# sourceMappingURL=chunk-C7FE5SD3.mjs.map